import React, { useEffect, useState } from 'react';
import { FaCheck, FaCar, FaExchangeAlt, FaInfoCircle } from "react-icons/fa";
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import '../css/Sidebar.css';
import '../css/Navbar.css';
import '../css/UserManagement.css';
import { authAPI, usersAPI, vehiclesAPI } from '../api/api';

const defaultPermissions = {
  can_see_rental_fee: false,
  can_see_map: false,
  can_see_obd: false,
  can_see_documents: false,
  can_see_ordered_cars: false,
};

const permissionList = [
  { key: 'can_see_rental_fee', label: 'Bérleti díj' },
  { key: 'can_see_map', label: 'Térkép' },
  { key: 'can_see_obd', label: 'OBD' },
  { key: 'can_see_documents', label: 'Dokumentumok' },
  { key: 'can_see_ordered_cars', label: 'Megrendelt autók' },
];

function UserModal({ open, onClose, onSave, user, isEdit, companyId, loading }) {
  const [form, setForm] = useState(user || {
    name: '',
    email: '',
    password: '',
    role: 'user',
    client_id: '',
    ...(user?.role === 'admin' ? {
      can_see_rental_fee: true,
      can_see_map: true,
      can_see_obd: true,
      can_see_documents: true,
      can_see_ordered_cars: true,
    } : defaultPermissions),
  });
  const [vehicles, setVehicles] = useState([]);
  const [showVehicles, setShowVehicles] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [selectedVehicleForTransfer, setSelectedVehicleForTransfer] = useState(null);

  useEffect(() => {
    setForm(user || {
      name: '',
      email: '',
      password: '',
      role: 'user',
      client_id: '',
      ...(user?.role === 'admin' ? {
        can_see_rental_fee: true,
        can_see_map: true,
        can_see_obd: true,
        can_see_documents: true,
        can_see_ordered_cars: true,
      } : defaultPermissions),
    });
  }, [user, open]);

  useEffect(() => {
    if (showVehicles) {
      fetchCompanyVehicles();
    }
    
    // Modal méretezése a járművek listája alapján
    const modalContent = document.querySelector('.modal-content');
    if (modalContent) {
      if (showVehicles) {
        modalContent.classList.add('with-vehicles');
      } else {
        modalContent.classList.remove('with-vehicles');
      }
    }
    
    // Cleanup: eltávolítjuk az osztályt amikor a modal bezáródik
    return () => {
      const modalContent = document.querySelector('.modal-content');
      if (modalContent) {
        modalContent.classList.remove('with-vehicles');
      }
    };
  }, [showVehicles]);

  // Automatikus jogosultság beállítás CSAK új user létrehozásakor
  useEffect(() => {
    // Csak akkor állítsuk be a jogokat ha új usert hozunk létre (nem edit mode)
    if (!isEdit) {
      if (form.role === 'admin' || form.role === 'boss') {
        setForm(prev => ({
          ...prev,
          can_see_rental_fee: true,
          can_see_map: true,
          can_see_obd: true,
          can_see_documents: true,
          can_see_ordered_cars: true,
        }));
      } else if (form.role === 'user') {
        setForm(prev => ({
          ...prev,
          can_see_rental_fee: false,
          can_see_map: false,
          can_see_obd: false,
          can_see_documents: false,
          can_see_ordered_cars: false,
        }));
      }
    }
  }, [form.role, isEdit]);

  const fetchCompanyVehicles = async () => {
    try {
      const vehiclesData = await vehiclesAPI.getAllVehiclesForUser();
      setVehicles(vehiclesData);
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    }
  };

    useEffect(() => {
    document.body.classList.add('cars-bg');
    return () => document.body.classList.remove('cars-bg');
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(form);
  };

  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{minWidth:320}}>
        <div className="modal-header">
          <h3>{isEdit ? 'Felhasználó szerkesztése' : 'Új felhasználó hozzáadása'}</h3>
          <button 
            type="button" 
            className="modal-close-btn" 
            onClick={onClose}
            aria-label="Bezárás"
          >
            ×
          </button>
        </div>
        <form className="user-add-form" onSubmit={handleSubmit}>
          {/* Rejtett felhasználónév mező az akadálymentességhez */}
          <input
            type="text"
            name="username"
            value={form.email}
            autoComplete="username"
            style={{ display: 'none' }}
            readOnly
          />
          <label>Név</label>
          <input 
            name="name" 
            value={form.name} 
            onChange={handleChange} 
            required 
            autoComplete="name"
          />
          <label>Email</label>
          <input 
            name="email" 
            value={form.email} 
            onChange={handleChange} 
            type="email" 
            required 
            autoComplete="email"
          />
          {!isEdit && (<>
            <label>Jelszó</label>
            <input 
              name="password" 
              value={form.password} 
              onChange={handleChange} 
              type="password" 
              required 
              autoComplete="new-password"
            />
          </>)}
          <label>Szerepkör</label>
          <select 
            name="role" 
            value={form.role} 
            onChange={handleChange}
            autoComplete="role"
          >
            <option value="user">Felhasználó</option>
            <option value="admin">Admin</option>
        
          </select>
          <div style={{marginTop:12,marginBottom:8,fontWeight:600}}>Jogosultságok:</div>
          <div className="user-add-permissions">
            {permissionList.map(perm => (
              <label key={perm.key}>
                <input
                  type="checkbox"
                  name={perm.key}
                  checked={!!form[perm.key]}
                  onChange={handleChange}
                />
                {perm.label}
              </label>
            ))}
          </div>
          <div style={{display:'flex',gap:8,marginTop:12}}>
            <button type="submit" disabled={loading}>
              {loading ? 'Feldolgozás...' : (isEdit ? 'Mentés' : 'Hozzáadás')}
            </button>
            <button type="button" onClick={onClose} className='cancel-button' disabled={loading}>
              Mégse
            </button>
          </div>
        </form>

        {/* Járművek szekció - csak szerkesztés módban */}
        {isEdit && (
          <div className="vehicles-section">
            <div className="vehicles-header">
              <button 
                type="button" 
                className="vehicles-toggle-btn"
                onClick={() => setShowVehicles(!showVehicles)}
              >
                <FaCar className="vehicles-icon" />
                {showVehicles ? 'Elrejtés' : 'Cég járművei megjelenítése'}
              </button>
            </div>

            {showVehicles && (
              <div className="vehicles-content">
                <h4>Járművek listája</h4>
                {vehicles.length > 0 ? (
                  <div className="vehicles-grid">
                    {vehicles.map(vehicle => (
                      <div key={vehicle.id} className="vehicle-card">
                        <div className="vehicle-info">
                          <div className="vehicle-brand-model">
                            {vehicle.brand} {vehicle.model}
                          </div>
                          <div className="vehicle-details">
                            <span className="vehicle-plate">{vehicle.plate_number}</span>
                            <span className="vehicle-chassis">Chassis: {vehicle.chassis_number17}</span>
                          </div>
                          <div className="vehicle-owner">
                            <strong>Tulajdonos:</strong> {vehicle.owner}
                          </div>
                        </div>
                        <button 
                          type="button"
                          className="transfer-vehicle-btn"
                          onClick={() => {
                            setSelectedVehicleForTransfer(vehicle);
                            setTransferModalOpen(true);
                          }}
                        >
                          <FaExchangeAlt className="transfer-icon" />
                          Átruházás
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-vehicles">
                    <FaInfoCircle className="info-icon" />
                    <span>Nincsenek járművek a cégben</span>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Átruházás modal - csak szerkesztés módban */}
        {isEdit && (
          <VehicleTransferModal
            open={transferModalOpen}
            onClose={() => {
              setTransferModalOpen(false);
              setSelectedVehicleForTransfer(null);
            }}
            fromUser={user}
            companyId={companyId}
            selectedVehicle={selectedVehicleForTransfer}
          />
        )}
      </div>
    </div>
  );
}

function VehicleTransferModal({ open, onClose, fromUser, companyId, selectedVehicle: preSelectedVehicle }) {
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedToUser, setSelectedToUser] = useState(null);
  const [transferReason, setTransferReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (open && companyId) {
      fetchCompanyVehicles();
      fetchCompanyUsers();
    }
  }, [open, companyId]);

  useEffect(() => {
    if (preSelectedVehicle) {
      setSelectedVehicle(preSelectedVehicle);
    }
  }, [preSelectedVehicle]);

  useEffect(() => {
    if (fromUser && users.length > 0) {
      const targetUser = users.find(u => u.id === fromUser.id);
      if (targetUser) {
        setSelectedToUser(targetUser);
      }
    }
  }, [fromUser, users]);

  const fetchCompanyVehicles = async () => {
    try {
      setLoading(true);
      const vehiclesData = await vehiclesAPI.getAllVehiclesForUser();
      setVehicles(vehiclesData);
    } catch (error) {
      console.error('Error fetching vehicles:', error);
      setMessage('Hiba a járművek lekérésekor');
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanyUsers = async () => {
    try {
      const clientId = companyId;
      const usersData = await usersAPI.getClientUsers(clientId);
      setUsers(usersData);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleTransfer = async () => {
    if (!selectedVehicle || !selectedToUser || !transferReason.trim()) {
      setMessage('Kérlek válaszd ki a járművet, a célfelhasználót és add meg az átruházás okát!');
      return;
    }

    // Használjuk a jármű owner_id mezőjét
    const fromUserId = selectedVehicle.owner_id;

    // Ha nincs jelenlegi tulajdonos, akkor "hozzárendelés", nem "átruházás"
    const isAssignment = !fromUserId;

    // Ha van tulajdonos, ellenőrizzük, hogy ne legyen ugyanaz, mint a célfelhasználó
    if (!isAssignment && selectedToUser.id === fromUserId) {
      setMessage('A célfelhasználó nem lehet ugyanaz, mint a jelenlegi tulajdonos!');
      return;
    }

    try {
      setLoading(true);
      const requestBody = {
        vehicle_id: selectedVehicle.id,
        to_user_id: selectedToUser.id,
        company_id: companyId,
        transfer_reason: transferReason
      };

      // Ha van from_user_id, akkor hozzáadjuk (átruházás)
      // Ha nincs, akkor null-ként küldjük (hozzárendelés)
      requestBody.from_user_id = fromUserId || null;

      console.log('Transfer request body:', requestBody);

      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/vehicle/transfer`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(requestBody),
      });

      console.log('Transfer response status:', response.status);

      // Először ellenőrizzük a response content type-ot
      const contentType = response.headers.get('content-type');
      console.log('Response content-type:', contentType);

      let result;
      if (contentType && contentType.includes('application/json')) {
        result = await response.json();
      } else {
        // Ha nem JSON, akkor olvassuk el mint szöveget debug célból
        const text = await response.text();
        console.error('Non-JSON response:', text.substring(0, 500));
        throw new Error(`A szerver nem JSON-t küldött vissza (status: ${response.status})`);
      }

      if (result.success) {
        const successMessage = isAssignment
          ? 'Jármű sikeresen hozzárendelve!'
          : 'Jármű sikeresen átruházva!';
        setMessage(successMessage);
        setTimeout(() => {
          onClose();
          setMessage('');
          setSelectedVehicle(null);
          setSelectedToUser(null);
          setTransferReason('');
        }, 2000);
      } else {
        setMessage(result.message || `Hiba a${isAssignment ? 'z hozzárendelés' : 'z átruházás'} során`);
      }
    } catch (error) {
      console.error('Transfer error:', error);
      const errorMessage = error.message || `Hiba a${isAssignment ? 'z hozzárendelés' : 'z átruházás'} során`;
      setMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  // Meghatározzuk, hogy hozzárendelés vagy átruházás
  const isAssignment = selectedVehicle && !selectedVehicle.owner_id;
  const modalTitle = isAssignment ? 'Jármű hozzárendelése' : 'Jármű átruházás';

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content vehicle-transfer-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{modalTitle}</h3>
          <button
            type="button"
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Bezárás"
          >
            ×
          </button>
        </div>

        {message && (
          <div className={`transfer-message ${message.includes('sikeresen') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}

        <div className="transfer-info">
          {!isAssignment && (
            <>
              <div className="transfer-user">
                <strong>Ról:</strong> {selectedVehicle?.owner || 'Nincs tulajdonos'}
              </div>
              <FaExchangeAlt className="transfer-arrow" />
            </>
          )}
          <div className="transfer-user">
            <strong>{isAssignment ? 'Felhasználó:' : 'Rá:'}</strong> {selectedToUser?.name || 'Nincs kiválasztva'}
          </div>
        </div>

        {!selectedVehicle ? (
          <div className="vehicle-selection">
            <label>Válaszd ki a járművet:</label>
            <select 
              value={selectedVehicle?.id || ''} 
              onChange={(e) => {
                const vehicle = vehicles.find(v => v.id === parseInt(e.target.value));
                setSelectedVehicle(vehicle);
              }}
            >
              <option value="">Válassz járművet...</option>
              {vehicles.map(vehicle => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.brand} {vehicle.model} - {vehicle.plate_number} ({vehicle.owner})
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className="selected-vehicle-info">
            <label>Kiválasztott jármű:</label>
            <div className="vehicle-display">
              <strong>{selectedVehicle.brand} {selectedVehicle.model}</strong> - {selectedVehicle.plate_number} ({selectedVehicle.owner})
            </div>
          </div>
        )}

        <div className="user-selection">
          <label>{isAssignment ? 'Hozzárendelés erre:' : 'Célfelhasználó:'}</label>
          <div className="selected-user-display">
            <strong>{selectedToUser?.name || 'Nincs kiválasztva'}</strong>
            {selectedToUser?.email && <span className="user-email"> ({selectedToUser.email})</span>}
          </div>
          <small className="user-selection-note">
            {isAssignment
              ? 'A jármű ehhez a felhasználóhoz lesz hozzárendelve'
              : 'A jármű csak erre a felhasználóra ruházható át'
            }
          </small>
        </div>

        <div className="transfer-reason">
          <label>{isAssignment ? 'Hozzárendelés oka:' : 'Átruházás oka:'}</label>
          <textarea
            value={transferReason}
            onChange={(e) => setTransferReason(e.target.value)}
            placeholder={isAssignment ? 'Add meg a hozzárendelés okát...' : 'Add meg az átruházás okát...'}
            rows="3"
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleTransfer}
            disabled={loading || !selectedVehicle || !selectedToUser || !transferReason.trim()}
            className="transfer-btn"
          >
            {loading ? 'Feldolgozás...' : (isAssignment ? 'Hozzárendelés' : 'Átruházás')}
          </button>
          <button type="button" onClick={onClose} className="cancel-button">
            Mégse
          </button>
        </div>
      </div>
    </div>
  );
}

const UserManagement = ({ isSidebarClosed, setIsSidebarClosed }) => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const clientId = currentUser?.client_id || currentUser?.company_id || currentUser?.company;
      const usersData = await usersAPI.getClientUsers(clientId);
      setUsers(usersData); 
    } catch (error) {
      console.error('Error fetching users:', error);
      setMessage('Hiba a felhasználók lekérésekor');
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = authAPI.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      // Csak akkor hívjuk meg a fetchUsers-t, ha van currentUser
      fetchUsers();
    }
    
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!currentUser || (currentUser.role !== 'admin')) { 
    return (
      <div style={{
        padding: 32, 
        textAlign: 'center',
        fontSize: '1.2rem',
        color: '#721c24',
        background: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '6px',
        margin: '20px'
      }}>
        ⚠️ Nincs jogosultságod a felhasználók kezeléséhez. 
        <br />
        <small style={{fontSize: '1rem', marginTop: '8px', display: 'block'}}>
          Csak admin felhasználók férhetnek hozzá ehhez az oldalhoz.
        </small>
      </div>
    );
  }

  const handleSave = async (user) => {
    try {
      setLoading(true);
      setMessage('');

      if (editUser) {
        // Felhasználó szerkesztése
        const updatedUser = await usersAPI.updateUser(editUser.id, user);

        // Jogosultságok frissítése külön
        const permissions = {
          can_see_rental_fee: user.can_see_rental_fee,
          can_see_map: user.can_see_map,
          can_see_obd: user.can_see_obd,
          can_see_documents: user.can_see_documents,
          can_see_ordered_cars: user.can_see_ordered_cars,
        };

        await usersAPI.updateUserPermissions(editUser.id, permissions);

        // Lokális állapot frissítése
        setUsers(users => users.map(u => u.id === editUser.id ? {
          ...updatedUser,
          ...permissions,
          company: editUser.company,
          client_id: editUser.client_id
        } : u));

        // Ha a szerkesztett user a bejelentkezett user, frissítsük a localStorage-t
        if (currentUser && (editUser.id === currentUser.id || editUser.id === currentUser.user_id)) {
          const updatedCurrentUser = {
            ...currentUser,
            ...permissions,
            role: user.role
          };
          localStorage.setItem('user', JSON.stringify(updatedCurrentUser));

          // Trigger storage event for usePermissions hook
          window.dispatchEvent(new Event('storage'));
        }

        setMessage('Felhasználó sikeresen frissítve!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        const userDataWithClientId = {
          ...user,
          client_id: currentUser.client_id || currentUser.company_id || currentUser.company
        };
        const newUser = await usersAPI.createUser(userDataWithClientId);

        // Lokális állapot frissítése (a backend már elmenti a jogosultságokat)
        setUsers(users => [
          ...users,
          {
            ...newUser,
            company: currentUser.company,
            client_id: currentUser.client_id || currentUser.company_id || currentUser.company,
          }
        ]);

        setMessage('Felhasználó sikeresen létrehozva!');
        setTimeout(() => setMessage(''), 3000);
      }
      
      setModalOpen(false);
      setEditUser(null);
      
      // Automatikus frissítés a felhasználók listájának
      setTimeout(() => {
        fetchUsers();
      }, 1000);
      
    } catch (error) {
      console.error('Error saving user:', error);
      setMessage(`Hiba történt: ${error.message}`);
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Biztosan törlöd ezt a felhasználót?')) return;
    
    try {
      setLoading(true);
      setMessage('');
      
      await usersAPI.deleteUser(id);
      setUsers(users => users.filter(u => u.id !== id));
      setMessage('Felhasználó sikeresen törölve!');
      setTimeout(() => setMessage(''), 3000);
      
      // Automatikus frissítés a felhasználók listájának
      setTimeout(() => {
        fetchUsers();
      }, 1000);
      
    } catch (error) {
      console.error('Error deleting user:', error);
      setMessage(`Hiba történt a törlés során: ${error.message}`);
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter(u => u.company === currentUser.company || u.client_id === currentUser.client_id);

  return (
    <>
      <Navbar isSidebarClosed={isSidebarClosed} setIsSidebarClosed={setIsSidebarClosed} />
      <Sidebar isCollapsed={isSidebarClosed} setIsCollapsed={setIsSidebarClosed} />
      <div className="page-content">
        <h2 style={{textAlign:'center',margin:'32px 0 24px 0', fontSize: '2rem'}}>Felhasználók</h2>
        
        {/* Üzenetek megjelenítése */}
        {message && (
          <div className={`user-message ${message.includes('sikeresen') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
        
        <div style={{display:'flex',justifyContent:'flex-start',alignItems:'center',marginBottom:16,flexWrap:'wrap',gap:8}}>
          <button 
            className="user-add-open-btn" 
            onClick={()=>{setEditUser(null);setModalOpen(true);}}
            disabled={loading}
          >
            {loading ? 'Feldolgozás...' : 'Új felhasználó'}
          </button>
        </div>
        {loading && users.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            fontSize: '1.1rem',
            color: '#666'
          }}>
            🔄 Felhasználók betöltése...
          </div>
        ) : !isMobile ? (
          <div className="user-table-wrapper">
            <table className="user-table">
              <thead>
                <tr>
                  <th>Név</th>
                  <th>Email</th>
                  <th>Szerepkör</th>
                  {permissionList.map(perm => (
                    <th key={perm.key}>{perm.label}</th>
                  ))}
                  <th>Műveletek</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role === 'admin' ? 'Admin' : 'Felhasználó'}</td>
                    {permissionList.map(perm => (
                      <td key={perm.key} style={{textAlign:'center'}}>
                        {user[perm.key] ? <FaCheck /> : ''}
                      </td>
                    ))}
                    <td style={{whiteSpace:'nowrap'}}>
                      <button
                        className="edit-btn-table"
                        onClick={()=>{setEditUser(user);setModalOpen(true);}}
                        disabled={loading}
                      >
                        Szerkesztés
                      </button>
                      <button
                        className="del-btn-table"
                        onClick={()=>handleDelete(user.id)}
                        disabled={loading || user.id === currentUser.id || user.id === currentUser.user_id}
                        title={user.id === currentUser.id || user.id === currentUser.user_id ? 'Saját magadat nem törölheted' : ''}
                      >
                        Törlés
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="user-table-mobile">
            {filteredUsers.map(user => (
              <div className="user-mobile-card" key={user.id}>
                <div className="user-mobile-row"><span className="user-mobile-label">Név:</span> {user.name}</div>
                <div className="user-mobile-row"><span className="user-mobile-label">Email:</span> {user.email}</div>
                <div className="user-mobile-row"><span className="user-mobile-label">Szerepkör:</span> {user.role === 'admin' ? 'Admin' : 'Felhasználó'}</div>
                {permissionList.map(perm => (
                  <div className="user-mobile-row" key={perm.key}>
                    <span className="user-mobile-label">{perm.label}:</span> {user[perm.key] ? <FaCheck /> : ''}
                  </div>
                ))}
                <div className="user-mobile-actions">
                  <button
                    className="edit-btn-table"
                    onClick={()=>{setEditUser(user);setModalOpen(true);}}
                    disabled={loading}
                  >
                    Szerkesztés
                  </button>
                  <button
                    className="del-btn-table"
                    onClick={()=>handleDelete(user.id)}
                    disabled={loading || user.id === currentUser.id || user.id === currentUser.user_id}
                    title={user.id === currentUser.id || user.id === currentUser.user_id ? 'Saját magadat nem törölheted' : ''}
                  >
                    Törlés
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        <UserModal
          open={modalOpen}
          onClose={()=>{setModalOpen(false);setEditUser(null);}}
          onSave={handleSave}
          user={editUser}
          isEdit={!!editUser}
          companyId={currentUser?.client_id || currentUser?.company_id || currentUser?.company}
          loading={loading}
        />
      </div>
    </>
  );
};

export default UserManagement; 